import React, { ReactNode } from 'react';
import { MaskedLink } from '@hz-design-system/web-ui';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import { ListingVerifiedSellerBadge } from '@/client/components/ListingsNew/components';

import Classes from './ListingSellerName.module.scss';

interface ListingSellerNameProps {
  children: ReactNode;
  link: string;
  isVerifiedSeller: boolean;
  as?: string;
  linkAs?: string;
}

const ListingSellerName: React.FC<ListingSellerNameProps> = ({
  children,
  link,
  isVerifiedSeller,
  as,
  linkAs = getSuitCSSClasses({ namespace: 'hz', name: 'TextLink' }),
}) => {
  return (
    <span className={as ? as : Classes[getSuitCSSClasses({ namespace: 'hz', name: 'Listing-seller-name-container' })]}>
      <MaskedLink className={linkAs} href={link}>
        <span className={getSuitCSSClasses({ namespace: 'hz', name: 'Listing-seller-name-new' })}>{`${children}`}</span>
      </MaskedLink>
      {isVerifiedSeller && <ListingVerifiedSellerBadge />}
    </span>
  );
};

export default ListingSellerName;
